<template>
    <div data-app>
        <v-app>
            <router-view></router-view>
        </v-app>
    </div>
</template>

<script>
    export default {
        name: 'App',
        watch: {
          '$route' (to, from) {
              document.title = to.meta.title || 'Masterkala ERP';
              this.$store.state.sidebarShow = false;
          }
        }        
    }



</script>

<style lang="scss">
    // Import Main styles for this application
    @import '../public/fontiran.css';
    @import 'assets/scss/style';
</style>
